<template>
  <div>
    <template v-if="$route.name != 'tournament' && $route.name != 'playerprofile' ">
      <b-row class="TitleArea">
        <b-col sm="12" lg="6">
          <template v-if="$route.name != 'home'">
            <h1 class="heading">Clutch Tour
            <template v-if="tournID == 'cpt'">Tier 1</template>
            <template v-else-if="tournID == 'cp2'">Tier 2</template>
            <template v-else-if="tournID == 'cp3'">Amateur</template>
            <template v-else-if="tournID == 'pam'">Pro-Ams</template>
            <template v-else-if="tournID == 'qsc'">Q-School</template>
             Latest</h1>
          </template>
          <template v-else>
            <h1 class="heading">Clutch Tour Latest News</h1>
          </template>
        </b-col>
        <b-col sm="12" lg="6" class="above769">
          <b-link to="/news" class="allNewsLink">
            <button class="Allbuttons" :style="colourTour" :class="{colorBtn : $route.name == 'schedule'}">
              See All News
            </button>
          </b-link>
        </b-col>
      </b-row>
      <div v-if="loading == true">
        <div class="loader"></div>
        <h2 class="loading">Loading...</h2>
      </div>
      <div class="below1200">
        <b-row :class="postsRow">
          <b-col
            lg="12"
            id="mobilePost"
            v-for="(posts, index) in SecondDatetime.slice(0, 3)"
            :key="'fourteendex' + index"
          >
            <b-nav-item :to="'/news/' + posts.slug" class="NewsArtileOne">
              <div class="overflowImage">
                <b-img
                  :class="postImg"
                  :src="
                      posts.better_featured_image.source_url
                  "
                  onerror="this.onerror=null;this.src='https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/course.png';"
                  fluid
                  alt="Responsive image"
                />
              </div>
              <div class="FirstPostContentBlock">
                <h1 class="postsTitle LeftImage">
                  <span v-html="posts.title.rendered"></span>
                </h1>
                <p class="date">{{posts.PostnewDate}}</p>
              </div>
              <!-- <span class="postText" v-html="posts.excerpt.rendered"></span> -->
            </b-nav-item>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" class="">
            <b-link to="/news" class="allNewsLink">
              <button class="Allbuttons" :style="colourTour" :class="{colorBtn : $route.name == 'schedule'}">
                See All News
              </button>
            </b-link>
          </b-col>
        </b-row>
        <!-- <div sm="12" lg="6" class="linkNews" >
          <b-link to="/news" class="allNewsLink">
            <button class="Allbuttons" :style="colourTour">
              See All News
            </button>
          </b-link>
        </div> -->
      </div>
      <div class="above1200">
        <b-row :class="postsRow">
          <b-col
            lg="4"
            id="mobilePost"
            v-for="(posts, index) in SecondDatetime.slice(0, 3)"
            :key="'fiftheendex' + index"
          >
            <b-nav-item :to="'/news/' + posts.slug" class="NewsArtileOne">
              <div class="overflowImage">
                <b-img
                  :class="postImg"
                  :src="
                      posts.better_featured_image.source_url
                  "
                  onerror="this.onerror=null;this.src='https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/course.png';"
                  fluid
                  alt="Responsive image"
                />
              </div>
              <div class="FirstPostContentBlock">
                <p class="date">{{posts.PostnewDate}}</p>
                <h1 class="postsTitle LeftImage">
                  <span v-html="posts.title.rendered"></span>
                </h1>
              </div>
              <!-- <span class="postText" v-html="posts.excerpt.rendered"></span> -->
            </b-nav-item>
          </b-col>
        </b-row>
      </div>
    </template>
    <template v-else>
        <b-row :class="postsRow">
          <b-col
            lg="4"
            id="mobilePost"
            v-for="(posts, index) in SecondDatetime.slice(0, 3)"
            :key="'sixteendex' + index"
          >
            <b-nav-item :to="'/news/' + posts.slug" class="NewsArtileOne">
              <div class="overflowImage">
                <b-img
                  :class="postImg"
                  :src="
                      posts.better_featured_image.source_url
                  "
                  onerror="this.onerror=null;this.src='https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/course.png';"
                  fluid
                  alt="Responsive image"
                />
              </div>
              <div class="FirstPostContentBlock">
                <p class="date">{{posts.PostnewDate}}</p>
                <h1 class="postsTitle LeftImage">
                  <span v-html="posts.title.rendered"></span>
                </h1>
              </div>
              <!-- <span class="postText" v-html="posts.excerpt.rendered"></span> -->
            </b-nav-item>
          </b-col>
        </b-row>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import apiCall from "@/services/api.js";
export default {
  name: "posts",
  props: ["config", 'tag', "course_code", "Year", 'count', 'featuredTrue', 'tournID'],
  data() {
    return {
      posts: [],
      tournPosts: [],
      postsRow: "posts",
      postImg: "postImg",
      loading: true
    };
  },
  computed: {
    dateTime:function(){
      let arr = [];
      console.log("arr")
      console.log(arr)
      this.posts.forEach((value) => {
        var dateOG = value.date.split('T')
        var splitDate = dateOG[0].split('-')
        var newDate = splitDate[2]+ '/' + splitDate[1] + '/' + splitDate[0]
        arr.push(newDate);
      });
      return arr
    },
    SecondDatetime: function() {
      let Allpost = this.posts
      console.log("Allpost")
      console.log(Allpost)
      // let arr = [];

      this.posts.forEach((value) => {
          var dateOG = value.date.split('T')
          var splitDate = dateOG[0].split('-')
          var newDate = splitDate[2]+ '/' + splitDate[1] + '/' + splitDate[0]        
          value.PostnewDate = newDate;
      });
      return Allpost
    },
    colourTour: function() {
      var backgroundColourTour = '';
      if (this.tournID == 'cpt') {
        backgroundColourTour = 'background-color: #bceff0'
      } else if (this.tournID == 'cp2') {
        backgroundColourTour = 'background-color: #bde9d8'
      } else if (this.tournID == 'cp3') {
        backgroundColourTour = 'background-color: #dfc3c2;color: #081C3F'
      } else if (this.tournID == 'pam') {
        backgroundColourTour = "background-color: #c3bcce;color: #081C3F"
      } else if (this.tournID == 'qsc') {
        backgroundColourTour = 'background-color: #ededc3'
      }
      return backgroundColourTour
    }
  },
  methods: {
    tournamentNews: function () {
      console.log('news added')
      console.log('tournament News')
        axios //add API Call
          .get('https://wp-cpt.ocs-software.com/wp-json/wp/v2/posts?tags=' + this.tag + "&randomadd=" + new Date().getTime())
          .then((response) => (this.posts = response.data));
      },
  },
  created() {
    var json = ''
    if (this.tournID == 'cpt') {
      json = "wp/v2/posts?categories=4"; 
    } else if (this.tournID == 'cp2') {
      json = "wp/v2/posts?categories=5";
    } else if (this.tournID == 'cp3') {
      json = "wp/v2/posts?categories=6";
    } else if (this.tournID == 'pam') {
      json = "wp/v2/posts?categories=7";
    } else if (this.tournID == 'qsc') {
      json = "wp/v2/posts?categories=8";
    } else {
      json = "wp/v2/posts";
    }
    apiCall
      .wpInfo(json)
      .then(({ data }) => {
        this.posts = data;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
  async mounted() {
    if (this.$route.name == 'tournament') {
      this.tournamentNews();      
    }
  }
};
</script>

<style scoped>
.row.TitleArea {
  padding-top: 70px;
}
button.Allbuttons.colorBtn {
  color: #081C3F;
}
h2.loading {
  padding-top: 20px;
  font-weight: 600;
  font-size: 24px;
  color: #081C3F;
  text-align: center;
  /* padding-bottom: 90px; */
}
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #081C3F; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
  display: block;
}
.loaderSection {
  padding-top: 30px;
  padding-bottom: 30px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
a.allNewsLink {
  text-decoration: none!important;
}
.linkNews {
  position: relative;
  top: -15px;
}
li.nav-item.NewsArtileOne:hover {
  transform: translateY(-10px);
}
li.nav-item.NewsArtileOne:hover > a > .FirstPostContentBlock{
  background-color: #081C3F;
  border: 0px solid;
}
li.nav-item.NewsArtileOne:hover > a > .FirstPostContentBlock > p{
  color: #00FFFE;
}
li.nav-item.NewsArtileOne:hover > a > .FirstPostContentBlock > h1.postsTitle{
  color: #fff;
}
li.nav-item.NewsArtileOne {
  border-radius: 6px;
    transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.rightHomePosts:hover {
  transform: translateY(-10px);
}
.TitleArea {
  padding-bottom: 30px;
}
.noPadSmallImage {
  padding-left: 0px;
}
.rightHomePosts {
  border: 1px solid #E0E0E0;
  border-radius: 6px;
    transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  /* border-left: 0px; */
}
li.nav-item.NewsArtileOne > a {
  padding-left: 0px;
}
.overflowImage.newsSmallImage {
  height: 190px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 6px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.Allbuttons {
  float: right;
  width: 272px;
  height: 52px;
  background: #081C3F;
  /* color: #081C3F; */
  color: #fff;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 0px;
  border: 0px solid #081C3F;
  font-size: 18px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  border-radius: 26px;
}
.Allbuttons:hover {
  float: right;
  width: 272px;
  height: 52px;
  background-color: #081C3F!important;
  background: #081C3F!important;
  color: #fff!important;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 0px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
  border-radius: 26px;
}
.heading{
  /* font-weight: 600; */
  font-size: 36px;
  color: #081C3F;
  padding-bottom: 10px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
.FirstPostContentBlock {
  border: 1px solid #E0E0E0;
  width: 100%;
  padding: 35px;
  height: 250px;
  border-top: 0px solid;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
p.date {
  color: #081C3F;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
}
h1.postsTitle.LeftImage {
  /* font-weight: 600; */
}
h1.postsTitle.rightTitles {
  font-size: 24px;
}
h1.postsTitle.rightTitles > span {
  font-size: 24px;
}
img.imageRight.img-fluid.postImg {
  border-radius: 50px;
  max-width: 100%;
  height: 188px;
  width: auto;
  float: right;
}
.img-fluid {
  max-width: 100%;
  height: auto;
  width: 100%;
}
span.postText {
  font-size: 12pt;
}
h1.postsTitle {
  font-size: 24px;
  padding-top: 15px;
  padding-bottom: 15px;
  color: #081C3F;
  /* font-weight: 600; */
}
.overflowImage {
  overflow: hidden;
  /* height: 330px; */
  /* max-height: 368px; */
  max-height: 300px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
#mobilePost:last-child {
  /* padding-right: 0px; */
}

.postRow {
  padding-bottom: 10px;
}
::v-deep .nav-link {
  color: black !important;
  width: 100%;
  text-align: left;
}
.moreNews>a{
  background-color: transparent;
  color: #081C3F!important;
}
#leftMore{
  color: #fff;
  background-color: #081C3F;
  border-radius: 10px;
  width: 20px;
  height: 20px;
  padding: 3px;
}
@media only screen and (max-width: 480px) {
  ::v-deep .nav-link {
    width: 100%;
  }
  #mobilePost {
    padding-top: 2%;
    padding-bottom: 2%;
  }
}
@media only screen and (max-width: 769px) {
  .above769 {
    display: none;
  }
}
@media only screen and (max-width: 990px) {
  .overflowImage {
    overflow: hidden;
    /* height: 330px; */
    /* max-height: 368px; */
    max-height: 100%;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  li.nav-item.NewsArtileOne > a {
    padding-left: 0px;
    padding-right: 0px;
  }
  .overflowImage.newsSmallImage {
    height: 190px;
    border-radius: 25px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
  }
  .FirstPostContentBlock {
    height: auto;
  }
  .Allbuttons {
    float: none;
    width: 100%;
    height: 52px;
    background: #081C3F;
    /* color: #081C3F; */
    color: #fff;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 0px;
    border: 0px solid #081C3F;
    font-size: 18px;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
    margin-top: 25px;
    margin-bottom: 5px;
    border-radius: 26px;
  }
  .Allbuttons:hover {
    float: none;
    width: 100%;
    height: 52px;
    background-color: #081C3F!important;
    background: #081C3F!important;
    color: #fff!important;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 0px;
    border: 1px solid #E8E8E8;
    transform: translateY(-10px);
    margin-top: 25px;
    margin-bottom: 5px;
    border-radius: 26px;
  }
  .heading {
    /* font-weight: 600; */
    font-size: 26px;
    color: #081C3F;
    text-align: left;
    padding-bottom: 0;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
  }
}
@media only screen and (max-width: 510px) {
  .TitleArea {
    padding-bottom: 0px;
  }
}
@media only screen and (max-width: 1165px) {
  #mobilePost:last-child {
    padding-right: 15px;
    margin-top: 2em;
  }
  div#mobilePost {
    margin-top: 1em;
  }
}
@media only screen and (min-width: 1202px) {
  .below1200 {
    display: none;
  }
}
@media only screen and (max-width: 1201px) {
  .above1200 {
    display: none;
  }
}
@media only screen and (max-width: 1350px) {
  .overflowImage.newsSmallImage {
    height: 100%;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 6px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
}
</style>
